export const CountriesPath = {
  base: 'countries'
};
